module.exports = __webpack_public_path__ + "img/pf.9e3240e0.svg";